import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LanguageService } from '../../services/parameters';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements OnInit, ControlValueAccessor {
  @Input() public maxCharLength = 0;
  @Input() public label = '';
  @Input() public placeholder: string;
  @Input() public requiredField = false;
  @Input() public tooltipDescription = '';
  @Input() public errorMessage?: string | any = '';
  @Input() public clearable = false;
  @Input() public isDisabled = false;
  @Input() public rows = 0;
  @ViewChild('textarea') textarea!: ElementRef;

  @Output() changeEvent = new EventEmitter();
  private typingTimer: any;
  private doneTypingInterval = 1000;

  public value = '';
  public max = Math.max;
  onChange = (_: any) => {};
  onTouch = () => {};

  constructor(private _languageService: LanguageService) {}

  ngOnInit(): void {}

  onInput(value: any) {
    if (value) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.changeEvent.emit();
      }, this.doneTypingInterval);
      this.value = value.value;
      this.onChange(this.value);
      const maxCharMessage = this._languageService.message('max-characters');
      if (this.errorMessage && this.errorMessage !== maxCharMessage) {
        this.errorMessage = this.errorMessage;
      } else {
        this.errorMessage = null;
        if (this.maxCharLength && value.value.length >= this.maxCharLength && !this.errorMessage) {
          this.errorMessage = maxCharMessage;
        }
      }
    }
  }

  writeValue(value: any): void {
    if (!value) {
      this.value = '';
      this.errorMessage = null;
      this.onChange(this.value);
    } else {
      this.value = value || '';
      this.onChange(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onTouched() {}

  public clearInput(): void {
    this.value = '';
    this.errorMessage = null;
    this.onTouch();
    this.onChange(this.value);
  }
  onKeyPress(event: any) {
    if (this.maxCharLength && this.value.length >= this.maxCharLength) {
      event.preventDefault(); // Esto evitará que se escriban más caracteres
    }
  }
}
